import React from "react";
import { HiOutlineViewList } from 'react-icons/hi';

import './style.css';


 let CruxImpact=(props)=> {





  
  return(
    <div>
       <nav  class="navbar navbar-expand-lg py-3">
  <div class="container">
    <a href="#" class="navbar-brand">
      <img src="https://bootstrapious.com/i/snippets/sn-nav-logo/logo.png" width="45" alt="" class="d-inline-block align-middle mr-2" />
      <span className="text-uppercase font-weight-bold">Company</span>
    </a>

    <button style={{backgroundColor:'#FFCD24',position:'absolute',top:20,right:30}} type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" className="navbar-toggler"><span  className="navbar-toggler-icon"></span> <HiOutlineViewList size={30} style={{position:'absolute',top:5,right:13,color:'#666B6E'}} /></button>

    <div id="navbarSupportedContent" className="collapse navbar-collapse">
      <ul className="navbar-nav ml-auto">
        <li className="nav-item active"><a href="#" className="nav-link" style={{color:'#050E2F'}} onClick={()=>props.history.push('/')} >Home <span className="sr-only">(current)</span></a></li>
        <li className="nav-item" ><a href="#" className="nav-link" style={{color:'#050E2F'}}   >Services</a></li>
         <li className="nav-item" ><a href="#" className="nav-link" style={{color:'#050E2F'}}      >About </a></li>
        <li className="nav-item"><a href="#" className="nav-link"  style={{color:'#050E2F'}}      >Contact </a></li>
        <li className="nav-item" ><a href="#" className="nav-link" style={{color:'#050E2F',width:120}}   >Case Studies</a></li>

        <li className="nav-item"><a href="#" className="nav-link"  style={{color:'#050E2F'}} onClick={()=>props.history.push('/signin')}      >Signin</a></li>

      </ul>
    </div>
  </div>
</nav>
    <div id="centerME">


<div className="boxStAc">
<h4 id="h4">
CRUX - Impact ScoreCard
</h4>

<br></br>






<h6 id="h6">
CRUX -Alignemnt scorecard evaluates strength of alignment amognst problem, root causes, solution and business goals</h6>










<div id='divL'>




<table id='tableAll'>

  <thead>
    <tr>
      <th scope="col">Question</th>
      <th scope="col">PainPoint Improvment /Game Changer</th>
     
    </tr>
  </thead>
  <tbody>
    <tr>
      <td data-label="Question">Time</td>
      <td data-label="PainPoint Improvment /Game Changer"> 
      <select >
    <option value="0">Combo Box:</option>
    <option value="1">1</option>
    <option value="2">2</option>
    <option value="3">3</option>
    </select></td>
     
    </tr>
   
    <tr>
      <td data-label="Question">Money</td>
      <td data-label="PainPoint Improvment /Game Changer"> 
      <select >
    <option value="0">Combo Box:</option>
    <option value="1">1</option>
    <option value="2">2</option>
    <option value="3">3</option>
    </select></td>
     
    </tr>



    <tr>
      <td data-label="Question">Effort</td>
      <td data-label="PainPoint Improvment /Game Changer"> 
      <select >
    <option value="0">Combo Box:</option>
    <option value="1">1</option>
    <option value="2">2</option>
    <option value="3">3</option>
    </select></td>
     
    </tr>




   
    <tr>
      <td data-label="Question">Total</td>
      <td data-label="PainPoint Improvment /Game Changer">
      <input type='text' placeholder="Locked"  id="lockedInput">
</input>
  </td>





    </tr>


  </tbody>
</table>


</div>




<div id="flexLef">

<button className="button2" onClick={()=>props.history.push('/cruxAlligment')} id='BackNext'>Back</button>


<button className="button2" onClick={()=>props.history.push('/PurchseDescionAllignemt')}  id='BackNext'>Next</button>



</div>


</div>







    </div>

</div>
  )


}



export default CruxImpact;